import { render, staticRenderFns } from "./Migrate.vue?vue&type=template&id=0333080e&scoped=true"
import script from "./Migrate.vue?vue&type=script&lang=js"
export * from "./Migrate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0333080e",
  null
  
)

export default component.exports